import AppFeatureEditor from '../AppFeatureEditor'

class QuarterFeatureEditor extends AppFeatureEditor {}

export default QuarterFeatureEditor
